// @DEPRECATED: Use tokens from @common/tokens instead.

export type AntBreakpointsType = keyof typeof AntBreakpoints;

export const AntBreakpoints = {
  xs: 480,
  xsPx: '480px',
  sm: 576,
  smPx: '576px',
  md: 768,
  mdPx: '768px',
  lg: 992,
  lgPx: '992px',
  xl: 1200,
  xlPx: '1200px',
  xxl: 1600,
  xxlPx: '1600px',
};

export type SpacingType = keyof typeof Spacing;

export const Spacing = {
  baseSpacing: 24,
  baseSpacingPx: '24px',
};

export type FontSizesType = keyof typeof FontSizes;

export const FontSizes = {
  small: '11px',
  medium: '14px',
  large: '16px',
};
